export default "__VITE_ASSET__4b0bfb57__"